import Secondary from '../layouts/Secondary'
import Login from '../views/auth/Login'

export const secondaryRouters = {
  path: '/',
  name: 'Secondary',
  component: Secondary,
  redirect: 'login',
  children: [
    {
      path: '',
      name: 'login',
      component: Login,
      meta: {
        noAuth: true
      }
    }
  ]
}
